import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../lib/api';

export interface ResendVerificationPayload {
  email: string;
}

export function useResendVerification() {
  const api = useApi();
  return useMutation({
    mutationFn: async ({ email }: ResendVerificationPayload): Promise<void> => {
      const { error, response } = await api.POST('/auth/resend-verification', { body: { email } });
      if (error) {
        const err = new Error('resend_verification_failed') as Error & {
          status?: number;
          body?: unknown;
        };
        err.status = response?.status;
        err.body = error;
        throw err;
      }
    },
  });
}
